var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 411.064,
    height: 394.5,
    viewBox: "0 0 411.064 394.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#13c4fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0533b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88e1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#84dcfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#79cdf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#67b5ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#4e94dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#2e6aca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#0736b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0533b3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1144 -3357)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1277.084 3444.53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.444,123.216V110.5q-4.668-.894-9.434-1.663v12.718q4.766.768,9.434,1.663Zm-16.969-15.508V96.453q-4.839-.669-9.763-1.2v11.255q4.925.536,9.763,1.2Zm33.3,6.369V98.732q-4.479-1.109-9.068-2.1v15.345q4.588.989,9.068,2.1Zm-50.855-8.33V83.092q-4.985-.429-10.046-.721v22.655q5.062.292,10.046.721Zm-36.448-1.276V81.815q-5.123.079-10.184.3v22.656q5.06-.219,10.184-.3Zm-18.105.728V76.707q-5.007.328-9.941.793v28.493q4.932-.465,9.941-.793Zm36.5-.545V72.063q-4.574-.161-9.2-.209l-1.094-.009v32.592l1.094.01q4.627.047,9.2.207Zm-54.156,2.151V66.035q-4.874.57-9.666,1.269v40.773q4.79-.7,9.666-1.271Zm-30.428-44.26A346.335,346.335,0,0,1,319.666,55.2c35.4.355,68.553,5.8,97.382,15.111v70.43c-28.829-9.3-61.986-14.756-97.382-15.109a346.336,346.336,0,0,0-75.381,7.346V62.547Z",
    transform: "translate(-244.285 -55.181)",
    fill: "#0533b3",
    opacity: 0.502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.886,88.36q4.588.989,9.068,2.1v15.345q-4.479-1.109-9.068-2.1V88.36Z",
    transform: "translate(-215.463 -46.909)",
    fill: "#0533b3",
    opacity: 0.753
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.521,98.128q4.766.768,9.434,1.663v12.718q-4.668-.894-9.434-1.663V98.128Z",
    transform: "translate(-218.796 -44.474)",
    fill: "#0533b3",
    opacity: 0.753
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.674,87.254q4.925.534,9.763,1.2V99.712q-4.839-.667-9.763-1.2V87.254Z",
    transform: "translate(-222.248 -47.185)",
    fill: "#0533b3",
    opacity: 0.753
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.4,76.945q5.062.29,10.046.721v22.655q-4.985-.429-10.046-.721V76.945Z",
    transform: "translate(-225.807 -49.755)",
    fill: "#0533b3",
    opacity: 0.753
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.747,68.52l1.094.009q4.627.047,9.2.209V101.33q-4.574-.161-9.2-.207l-1.094-.01V68.52Z",
    transform: "translate(-229.46 -51.856)",
    fill: "#0533b3",
    opacity: 0.753
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.112,76.8q5.06-.219,10.184-.3V99.156q-5.123.077-10.184.3V76.8Z",
    transform: "translate(-233.109 -49.866)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.815,73.2q4.932-.465,9.941-.793V100.9q-5.007.328-9.941.793V73.2Z",
    transform: "translate(-236.673 -50.886)",
    fill: "#0533b3",
    opacity: 0.753
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.9,65.138q4.79-.7,9.666-1.269v40.772q-4.874.57-9.666,1.271V65.138Z",
    transform: "translate(-240.142 -53.015)",
    fill: "#0533b3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1485.716 3475.946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.85,219.822V175.554c-1.026-15.087-7-29.468-17.018-42.614v44.268c10.022,13.147,15.993,27.528,17.018,42.614ZM457.71,170.99V126.721a126.661,126.661,0,0,0-11.721-11.547v44.268A126.656,126.656,0,0,1,457.71,170.99Zm-18.972-17.448V109.273A171.61,171.61,0,0,0,423.8,99.11v44.268a171.613,171.613,0,0,1,14.938,10.163ZM413.77,150.76V80.328c40.783,21.637,66.239,52.579,66.239,86.813v70.43c0-34.234-25.456-65.176-66.239-86.812Z",
    transform: "translate(-410.662 -80.328)",
    fill: "#0533b3",
    opacity: 0.502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.041,122.44c10.022,13.147,15.993,27.528,17.018,42.614v44.268c-1.026-15.087-7-29.468-17.018-42.614V122.44Z",
    transform: "translate(-400.871 -69.829)",
    fill: "#0533b3",
    opacity: 0.753
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.559,108.22a126.654,126.654,0,0,1,11.721,11.547v44.268a126.648,126.648,0,0,0-11.721-11.547V108.22Z",
    transform: "translate(-404.232 -73.374)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.8,95.362a171.617,171.617,0,0,1,14.938,10.163v44.268A171.617,171.617,0,0,0,421.8,139.63V95.362Z",
    transform: "translate(-408.66 -76.58)",
    fill: "#0533b3",
    opacity: 0.753
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.361,273.869V260.231c32.868-19.407,54.263-45.283,57.761-74.07V199.8c-3.5,28.787-24.893,54.663-57.761,74.07ZM480.6,221.931V151.5c-1.048,34.449-27.675,65.2-69.315,86.4v70.43c41.64-21.2,68.267-51.953,69.315-86.4Z",
    transform: "translate(-411.282 -62.583)",
    fill: "#0533b3",
    opacity: 0.502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.911,179.244c-3.5,28.787-24.893,54.663-57.761,74.07v13.639c32.868-19.407,54.263-45.283,57.761-74.07V179.244Z",
    transform: "translate(-409.071 -55.666)",
    fill: "#0533b3",
    opacity: 0.753
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1273.228 3667.086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.626,304.125V288.238q12.16-.663,23.891-2.121V302q-11.716,1.45-23.891,2.121Zm-38.1.074V275.245q7.286.369,14.716.445,5.075.051,10.1-.039v28.954q-5.019.088-10.1.038-7.427-.073-14.716-.444ZM261.8,300.4V256.13q11.519,1.825,23.558,2.89v44.268q-12.025-1.055-23.558-2.888Zm111.268-.189V253.458q11.435-1.857,22.312-4.434v46.753q-10.862,2.569-22.312,4.434Zm41.1-66.887c-30.017,9.237-64.45,14.328-100.93,13.964A343.2,343.2,0,0,1,241.2,239.1v70.43a343.2,343.2,0,0,0,72.04,8.193c36.48.365,70.913-4.726,100.93-13.964V233.324Z",
    transform: "translate(-241.199 -233.324)",
    fill: "#0533b3",
    opacity: 0.502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.246,254.469q-12.025-1.057-23.558-2.89v44.27q11.519,1.823,23.558,2.888V254.469Z",
    transform: "translate(-237.088 -228.773)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.473,275.581q-11.716,1.45-23.891,2.121V293.59q12.16-.663,23.891-2.121V275.581Z",
    transform: "translate(-222.155 -222.788)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.063,245.891q-10.862,2.569-22.312,4.434v46.753q11.435-1.857,22.312-4.434V245.891Z",
    transform: "translate(-214.883 -230.191)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.894,267.285q-5.018.088-10.1.039-7.427-.075-14.716-.445v28.954q7.286.367,14.716.444,5.075.051,10.1-.038V267.285Z",
    transform: "translate(-229.759 -224.958)",
    fill: "#0533b3",
    opacity: 0.753
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1144 3464.591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.914,154.075V139.9a85.637,85.637,0,0,0-10.01,18.893v42a85.645,85.645,0,0,1,10.01-18.895v-14.18q1.831-2.635,3.874-5.207v7.647a114.432,114.432,0,0,1,8.472-9.5v-7.647c13.285-13.371,30.981-25.1,51.928-34.544V104.823q-5.592,2.521-10.867,5.255-2.639,1.368-5.195,2.786a161.236,161.236,0,0,0-34.669,25.312q-.605.594-1.2,1.191V131.72a114.432,114.432,0,0,0-8.472,9.5v7.647q-2.043,2.571-3.874,5.207Zm-12.751-.444c8.009-34.37,41.68-63.97,89.44-82.393v70.43c-47.76,18.422-81.431,48.023-89.44,82.393v-70.43Z",
    transform: "translate(-137.66 -71.239)",
    fill: "#0533b3",
    opacity: 0.502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.715,132.665q.592-.6,1.2-1.191v13.639a152.16,152.16,0,0,1,24.8-19.447q4.758-3.028,9.866-5.866V106.162q2.556-1.417,5.195-2.786v13.639q5.272-2.732,10.867-5.255v0C191.7,121.2,174,132.932,160.715,146.3V132.665Zm-12.346,14.708q1.831-2.635,3.874-5.207V155.8q-2.043,2.571-3.874,5.207V147.373Z",
    transform: "translate(-135.115 -64.537)",
    fill: "#0533b3",
    opacity: 0.753
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.118,103.376q5.272-2.732,10.867-5.255V111.76q-5.592,2.521-10.867,5.255V103.376Z",
    transform: "translate(-124.457 -64.537)",
    fill: "#0533b3",
    opacity: 0.878
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.21,128.7a152.159,152.159,0,0,1,24.8-19.447v13.639a152.159,152.159,0,0,0-24.8,19.447V128.7Z",
    transform: "translate(-132.412 -61.762)",
    fill: "#0533b3",
    opacity: 0.878
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.063,110.423q4.758-3.028,9.866-5.866V118.2q-5.1,2.835-9.866,5.866V110.423Z",
    transform: "translate(-127.462 -62.932)",
    fill: "#0533b3",
    opacity: 0.973
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.357,145.087a85.637,85.637,0,0,1,10.01-18.893v14.18a85.665,85.665,0,0,0-10.01,18.893v13.639a85.665,85.665,0,0,1,10.01-18.893v14.18a85.646,85.646,0,0,0-10.01,18.895v-42Z",
    transform: "translate(-137.113 -57.538)",
    fill: "#0533b3",
    opacity: 0.753
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.357,156.437a85.664,85.664,0,0,1,10.01-18.893v13.639a85.666,85.666,0,0,0-10.01,18.893V156.437Z",
    transform: "translate(-137.113 -54.708)",
    fill: "#0533b3",
    opacity: 0.878
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.47,150.437a114.437,114.437,0,0,1,8.472-9.5v7.647a114.437,114.437,0,0,0-8.472,9.5v-7.647Zm0-21.286a114.436,114.436,0,0,1,8.472-9.5V127.3a114.442,114.442,0,0,0-8.472,9.5v-7.647Z",
    transform: "translate(-134.342 -59.169)",
    fill: "#0533b3",
    opacity: 0.753
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.47,135.272a114.436,114.436,0,0,1,8.472-9.5V139.41a114.442,114.442,0,0,0-8.472,9.5V135.272Z",
    transform: "translate(-134.342 -57.643)",
    fill: "#0533b3",
    opacity: 0.878
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.905,293.579v-11.9q3.577,1.917,7.31,3.737v11.9q-3.731-1.818-7.31-3.735Zm-23.436-14.869V256.779q2.972,2.239,6.122,4.393V283.1q-3.15-2.153-6.122-4.393Zm11.171,7.718V260.562q3.285,2.084,6.739,4.078v25.866q-3.454-1.994-6.739-4.078Zm-29.97-24.7v-28.7q2.281,2.509,4.762,4.947v28.7q-2.481-2.438-4.762-4.947Zm8.785,8.734V239.372q2.637,2.38,5.465,4.684v31.091q-2.826-2.3-5.465-4.685Zm-22.4-27.5V209.251q1.516,2.738,3.257,5.417v33.708q-1.739-2.68-3.257-5.418Zm6.119,9.585v-43.85q1.91,2.631,4.032,5.2v43.849q-2.121-2.565-4.032-5.2Zm-10.8-19.531V183.489q1.1,2.833,2.441,5.616v49.523q-1.336-2.781-2.441-5.616ZM224.252,244c-47.119-18.983-79.674-48.971-86.492-83.327v70.43c6.818,34.356,39.372,64.344,86.492,83.327V244Z",
    transform: "translate(-137.76 -48.941)",
    fill: "#0533b3",
    opacity: 0.502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.1,184.552q-1.336-2.783-2.441-5.616v49.523q1.1,2.833,2.441,5.616V184.552Z",
    transform: "translate(-137.038 -44.388)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.66,204.974q-1.739-2.678-3.257-5.417v33.707q1.516,2.738,3.257,5.418V204.974Z",
    transform: "translate(-136.104 -39.247)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.333,204.307q-2.121-2.565-4.032-5.2v43.85q1.91,2.629,4.032,5.2V204.307Z",
    transform: "translate(-134.883 -39.358)",
    fill: "#0533b3",
    opacity: 0.753
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.06,223.537q-2.481-2.438-4.762-4.947v28.7q2.281,2.509,4.762,4.947v-28.7Z",
    transform: "translate(-133.387 -34.501)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.795,228.351q-2.826-2.3-5.464-4.684v31.089q2.637,2.382,5.464,4.685V228.351Z",
    transform: "translate(-131.634 -33.236)",
    fill: "#0533b3",
    opacity: 0.753
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.467,241.993q-3.15-2.153-6.122-4.393v21.931q2.972,2.238,6.122,4.393V241.993Z",
    transform: "translate(-129.636 -29.762)",
    fill: "#0533b3",
    opacity: 0.753
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.026,244.706q-3.454-1.994-6.739-4.078v25.866q3.285,2.084,6.739,4.078V244.706Z",
    transform: "translate(-127.407 -29.007)",
    fill: "#0533b3",
    opacity: 0.753
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.414,261.267q-3.731-1.82-7.31-3.737v11.9q3.577,1.917,7.31,3.735v-11.9Z",
    transform: "translate(-124.959 -24.793)",
    fill: "#0533b3",
    opacity: 0.753
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M414.4,187.563v11.012l-95.29,55.015-95.292-55.017V187.561Z",
    transform: "translate(1030.417 3422.353)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.106,253.557,223.814,198.54l95.29-55.015L414.4,198.542Z",
    transform: "translate(1030.417 3411.374)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.106,241.42l-94.178-54.374-1.114.643,95.292,55.017L414.4,187.691l-1.114-.643Z",
    transform: "translate(1030.417 3422.225)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.716,238.332l-73.294-42.316L314.714,153.7l73.294,42.316Z",
    transform: "translate(1034.807 3402.911)",
    opacity: 0.5,
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.087,145.16l73.294,42.316v10.67L300.087,155.83Z",
    transform: "translate(1049.434 3411.782)",
    opacity: 0.5,
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.716,155.83l-73.294,42.315v-10.67l73.292-42.315Z",
    transform: "translate(1034.807 3411.782)",
    opacity: 0.5,
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.716,229.791l-73.294-42.316,73.292-42.315,73.294,42.316Z",
    transform: "translate(1034.807 3411.782)",
    opacity: 0.5,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.933,199.314,276.646,182.4,305.932,165.5l29.287,16.909Z",
    transform: "translate(1043.589 3416.852)",
    fill: "#0533b3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.932,167.053l27.939,16.131,1.347-.778L305.932,165.5l-29.286,16.908,1.347.778Z",
    transform: "translate(1043.589 3416.852)",
    fill: "#0533b3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.089,221.346v10.67L373.381,189.7v-10.67Z",
    transform: "translate(1049.434 3420.227)",
    opacity: 0.5,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.422,179.03V189.7l73.294,42.316v-10.67Z",
    transform: "translate(1034.807 3420.226)",
    opacity: 0.5,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.716,220.3l-72.285-41.734-1.009.582,73.294,42.316,73.292-42.315L387,178.566Z",
    transform: "translate(1034.807 3420.11)",
    fill: "#0533b3",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1304.523 3357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.481,225.374s1.124,1.172,2.288,2.551,4.443,3.3,5.819,4.155,7.682,5.633,9,10.341-3.189,5.329-7.8,4.511-8.917-5.07-10.171-6.605-5.619-5.02-11.274-7.948-2.237-6.866-2.237-6.866Z",
    transform: "translate(-174.218 -0.416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.945,232.279a17.565,17.565,0,0,0-1.2,4.839c-.263,2.723-.646,8.624-.786,10.351a14.6,14.6,0,0,0,2.841,9.995c3.037,4.044,4.607,5.641,8.644,4.05s3.949-8.369,3.234-11.853a96.725,96.725,0,0,1-1.306-12.1,2.435,2.435,0,0,0-.231-1.342Z",
    transform: "translate(-225.683 6.66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.485,192.422s-.85,31.082-8.1,47.58a120.006,120.006,0,0,0-5.872,31.815,6.181,6.181,0,0,1-.5,5.4c-1.7,2.42-12.333,4.635-14.089-3.313s-1.083-22.82.848-29.022-.686-23.294-.686-23.294-2.908,1.857-6.718,14.136-6.613,16.966-7.923,20.358-2.517,24.2-1.687,34.366c0,0-8.612,1.223-11.1-2.894s-3.323-25.414-2.691-32.2,3.471-28.54,3.08-35.271-1.792-12.2-.253-18.918S266.776,179.5,266.776,179.5Z",
    transform: "translate(-205.287 -47.43)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.048,215.394c-.391-6.731-1.792-12.2-.253-18.918.579-2.527,7.362-6.214,15.6-9.833,13.907-1.27,31.543-2.744,32.758-2.557a45.441,45.441,0,0,1,6.356,2.215l.972,1.44s-.053,1.889-.239,4.977c-3.244.97-9.484-.032-9.484-.032-.879,2.181-6.3,9.932-13.038,13.277s-26.463,2.2-27.595,3.471-1.351,18.287-1.225,20.451-1.859,15.784-3.693,27.83c-1.8,11.849.942,26.25,1.033,26.714a4.856,4.856,0,0,1-1.583-1.559c-2.491-4.117-3.323-25.414-2.691-32.2S220.439,222.124,220.048,215.394Z",
    transform: "translate(-205.287 -42.748)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.764,137.771s10.082,2.3,13.473,3.1a1.747,1.747,0,0,1,1.229,1.065c.978,2.478,3.434,10.181,1.583,21.425a106.581,106.581,0,0,0-1.553,23.124l4.663,24.27s5.862,23.116,5.356,23.748-13.5,10.521-17.56,9.128-2.725-3.691-2.725-3.691-3.29,16.752-17.851,16.592-26.455-.115-28.927-6,.676-30.628,3.244-40.424,8.67-29.324,8.67-29.324l-21.328-23.606,18.228-13.919s4.353-8.091,6.143-9.12,2.723-.158,2.723-.158Z",
    transform: "translate(-208.777 -94.442)",
    fill: "#453c9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.764,137.771s10.082,2.3,13.473,3.1a1.747,1.747,0,0,1,1.229,1.065c.978,2.478,3.434,10.181,1.583,21.425a106.581,106.581,0,0,0-1.553,23.124l4.663,24.27s5.862,23.116,5.356,23.748-13.5,10.521-17.56,9.128-2.725-3.691-2.725-3.691-3.29,16.752-17.851,16.592-26.455-.115-28.927-6,.676-30.628,3.244-40.424,8.67-29.324,8.67-29.324l-21.328-23.606,18.228-13.919s4.353-8.091,6.143-9.12,2.723-.158,2.723-.158Z",
    transform: "translate(-208.777 -94.442)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.27,133.92s-3.724,4.505,1.634,10.586c3.3,3.744,8.97,11.815,13.806,20.2,3.019,5.236,5.811,8.027,7.393,12.526,0,0,.221-5.346.433-13.6.2-7.786.306-15.879-.043-17.916C249.774,141.517,231.385,131.879,227.27,133.92Z",
    transform: "translate(-199.242 -94.432)",
    fill: "#f0f6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.941,165.82s1.907,1.185,2.565,1.087,2.77-2.15,2.77-2.15,5.285-.1,5.862-2.361a49.167,49.167,0,0,1,1.492-5.724c.535-1.176,2.815-6.826,2.833-9.118s-.069-6.386.921-8.555,2.325-23.861-18.623-23.249-14.441,22.363-14.441,22.363-1.529.652-.6,3.452,1.134,3.09,1.606,4.479a6.21,6.21,0,0,0,2.037,3.41l.348,2.58a10.358,10.358,0,0,0,1.608,7.767C230.92,163.629,239.941,165.82,239.941,165.82Z",
    transform: "translate(-197.988 -112.78)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.3,137.328s2.233.332,9.48,18.564c4.046,10.173,10.286,20.708,11.609,28.269s.585,15.642-.909,16.211c-1.438.549-27.477,10.292-35.628,13.368a.767.767,0,0,1-1.025-.587l-2.246-12.574,16.158-6.243s3.078-3.762,5.971-5.174c0,0-3.24-5.969-3.033-7.6s-.29-18.5,1.6-25.357S225.3,137.328,225.3,137.328Z",
    transform: "translate(-156.268 -90.652)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.575,162.785s2.223-1.494,2.774-1.709,3.527-1.229,4.094-1.482a11.248,11.248,0,0,1,3.025.042.947.947,0,0,1,.739.492c.688,1.276,2.6,4.987,2.387,6.4,0,0-5.38,3.4-5.981,4.914l-.859.184S218.152,163.9,215.575,162.785Z",
    transform: "translate(-156.002 -67.927)",
    fill: "#fcd1c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.8,175.625c.618-2.357,1.44-5.279,2.333-8.355L263.856,181.3a34.507,34.507,0,0,1-26.963,11.27,22.539,22.539,0,0,1-10.635-3.359A130.686,130.686,0,0,1,228.8,175.625Z",
    transform: "translate(-212.878 -59.965)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.632,145.256s8.632,1.189,15.6,12.24a167.247,167.247,0,0,1,12.054,23.841l.241,1.438a5.818,5.818,0,0,0,8.112,4.36c7.362-3.286,18.268-8.257,20.3-9.75a18.768,18.768,0,0,1,8.3,12.121c1.419,6.791,1.059,6.814,1.059,6.814s-29.061,13.563-40.285,13.429-25.461-37.033-27.028-44.66S215.694,147.412,220.632,145.256Z",
    transform: "translate(-217.371 -82.527)",
    fill: "#24126a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.632,145.256s8.632,1.189,15.6,12.24a167.247,167.247,0,0,1,12.054,23.841l.241,1.438a5.818,5.818,0,0,0,8.112,4.36c7.362-3.286,18.268-8.257,20.3-9.75a18.768,18.768,0,0,1,8.3,12.121c1.419,6.791,1.059,6.814,1.059,6.814s-29.061,13.563-40.285,13.429-25.461-37.033-27.028-44.66S215.694,147.412,220.632,145.256Z",
    transform: "translate(-217.371 -82.527)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.308,170.724s-3.665,3.428-5.261,1.551-1.126-2.086-1.126-2.086-3.3-.03-3.7-2.1-2.027-.974-2.12-3.278,2.671-1.831,2.671-1.831Z",
    transform: "translate(-211.21 -64.397)",
    fill: "#453c9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.508,171.913s-1.008-.94-2.308-2.039-3.4-5.651-3.758-6.052-4.74-3.766-6.852-3.823-.545,2.306-.059,2.64S237.082,164,237.082,164s2.122,1.784,2.363,2.045-5.9-.423-6.878.176a1.665,1.665,0,0,0-.059,2.6,2.393,2.393,0,0,0,1.215.411,2.137,2.137,0,0,0,1.15,2.707c1.845.856,2.268.381,2.268.381s.16,3.2,3.2,2.561Z",
    transform: "translate(-207.979 -67.419)",
    fill: "#fcd1c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.4,129.4s2.736,8.7-4.463,6.228-13.708-6.621-15.968-5.044c-1.721,1.2-1.642,4.886-1.507,6.577a2.507,2.507,0,0,1-.431,1.622l-2.134,3.1a2.382,2.382,0,0,0-.413,1.183l-.152,2.156a1.083,1.083,0,0,1-1.016,1l-.492.028a1.08,1.08,0,0,1-1.128-.893l-.557-3.171s-1.693-4.262-5.275-2.588c0,0-2.393-3.218-1.6-10.1s3.878-14.034,17.377-15.178S257.4,129.4,257.4,129.4Z",
    transform: "translate(-198.536 -114.276)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.277,145.627l2.019-1.567a10.886,10.886,0,0,1,2.6,3.2c.729,1.646,0,6.88,0,6.88l.616,1.057.757-1.383.64-6.188s-.686-4.572-.753-4.69-3.9.407-3.9.407A7.934,7.934,0,0,0,229.277,145.627Z",
    transform: "translate(-191.04 -84.924)",
    fill: "#c4ccd6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.207,141.213a6.866,6.866,0,0,1,3.13.952s-2.266.111-2.624.152S226.207,141.213,226.207,141.213Z",
    transform: "translate(-178.257 -86.67)",
    fill: "#c4ccd6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.821,141.678l-3.622,3.386s3.179,1.464,4.068,4.307c0,0,3.942.735,4.3-.693s-.01-5.024.462-6.619S230.821,141.678,230.821,141.678Z",
    transform: "translate(-186.983 -86.647)",
    fill: "#f9ae30",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.052,144.908a20.149,20.149,0,0,0,1.409,4.189c.735,1.223,1.488,2.594,1.488,2.594l-.089,17.383s-6.392-13.178-7.779-15.847c0,0,.213-6.346.816-7.547S231.052,144.908,231.052,144.908Z",
    transform: "translate(-182.614 -82.958)",
    fill: "#f9ae30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.982,132.186C235.181,144.3,247,147.9,247,147.9s-2.112,2.051-2.77,2.15-2.565-1.087-2.565-1.087-9.021-2.191-11.625-6.02a10.358,10.358,0,0,1-1.608-7.767l-.348-2.58A2.857,2.857,0,0,0,230.982,132.186Z",
    transform: "translate(-199.708 -95.921)",
    fill: "#ed985f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.843,139.19s1.658,5.72,1.873,5.935,4.165-.241,4.165-.241l-1.92,3.635s19.888,21.33,24.011,32.8A243.382,243.382,0,0,0,229,149.411l2.345-3.548-4.066.794Z",
    transform: "translate(-205.179 -88.743)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.294,136.7l1.055,1.2-1.239,1.156,3.677,3.325s1.124,23.329-3.365,38.784c0,0,6.095-14.176,4.712-39.42l-3.979-2.7,1.3-1.282Z",
    transform: "translate(-167.962 -91.298)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.165,203a1.275,1.275,0,0,0-.138.107l5.151-5.483c-2.377,3.353.362,18.71.646,22.227s-2.752,10.776-3.888,19.283,1.191,20.623,1.2,20.66a6.553,6.553,0,0,1-3.13-4.477c-1.758-7.948-1.083-22.82.848-29.022S229.165,203,229.165,203Z",
    transform: "translate(-187.364 -28.851)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.12,138.276a1.08,1.08,0,0,1-1.128-.893l-.557-3.171s-1.693-4.262-5.275-2.588c0,0-2.258-3.056-1.648-9.557,3.981,5.977,12.815,8.735,12.815,8.735l-2.134,3.1a2.382,2.382,0,0,0-.413,1.181l-.152,2.158a1.083,1.083,0,0,1-1.017,1Z",
    transform: "translate(-209.828 -106.292)",
    fill: "#222f3e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistic);
export default __webpack_public_path__ + "static/media/statistic.bb4276dd443af2df78b6ec4dcd1b7835.svg";
export { ForwardRef as ReactComponent };